(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papoyettes-cart"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(root) {
      if (!root || root.dataset.pyBound === '1' || !window.fetch) return;
      root.dataset.pyBound = '1';

      root.addEventListener('click', function (event) {
        var link = event.target.closest('a[data-py-cart-qty]');
        if (!link || link.classList.contains('is-off')) return;
        event.preventDefault();
        link.style.opacity = '0.5';
        fetch(link.getAttribute('href'), {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then(function () {
            window.location.reload();
          })
          .catch(function () {
            window.location.href = link.getAttribute('href');
          });
      });
    }

    document.querySelectorAll('[data-py-cart]').forEach(bind);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["papoyettes-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function syncSubject(root) {
      var valueInput = root.querySelector('[data-py-subject-value]');
      var customWrap = root.querySelector('[data-py-subject-custom-wrap]');
      var customInput = root.querySelector('[data-py-subject-custom]');
      var selected = root.querySelector('[data-py-subject-choice]:checked');
      if (!valueInput || !selected) return;

      var isOther = selected.hasAttribute('data-py-subject-other');
      if (customWrap) customWrap.hidden = !isOther;
      if (customInput) {
        customInput.required = isOther;
        if (!isOther) {
          customInput.setCustomValidity('');
          customInput.value = '';
        }
      }

      if (isOther) {
        valueInput.value = customInput ? customInput.value.trim() : '';
      } else {
        valueInput.value = selected.value;
      }
    }

    function applyUrlPrefill(root) {
      var params = new URLSearchParams(window.location.search);
      var subject = (params.get('sujet') || '').trim();
      var message = (params.get('message') || '').trim();
      if (!subject && !message) return false;

      if (subject) {
        var freeInput = root.querySelector('input[type="text"][name="contact[Sujet]"]');
        if (freeInput) {
          if (!freeInput.value) freeInput.value = subject;
        } else {
          var match = null;
          var other = null;
          root.querySelectorAll('[data-py-subject-choice]').forEach(function (choice) {
            if (choice.hasAttribute('data-py-subject-other')) {
              other = choice;
            } else if (choice.value.trim().toLowerCase() === subject.toLowerCase()) {
              match = choice;
            }
          });
          if (match) {
            match.checked = true;
          } else if (other) {
            other.checked = true;
            var customInput = root.querySelector('[data-py-subject-custom]');
            if (customInput && !customInput.value) customInput.value = subject;
          }
        }
      }

      var body = root.querySelector('textarea[name="contact[body]"]');
      if (message && body && !body.value) body.value = message;
      return true;
    }

    function bindRoot(root) {
      var form = root.querySelector('.papoyettes-contact__form');
      if (!form || form.dataset.pyBound === '1') return;
      form.dataset.pyBound = '1';

      form.addEventListener('change', function (event) {
        if (event.target && event.target.matches('[data-py-subject-choice]')) {
          syncSubject(root);
        }
      });

      form.addEventListener('input', function (event) {
        if (event.target && event.target.matches('[data-py-subject-custom]')) {
          syncSubject(root);
        }
      });

      form.addEventListener('submit', function (event) {
        syncSubject(root);
        var valueInput = root.querySelector('[data-py-subject-value]');
        var customInput = root.querySelector('[data-py-subject-custom]');
        var selected = root.querySelector('[data-py-subject-choice]:checked');
        if (selected && selected.hasAttribute('data-py-subject-other')) {
          var custom = customInput ? customInput.value.trim() : '';
          if (!custom) {
            event.preventDefault();
            if (customInput) {
              customInput.setCustomValidity('Indique un sujet, s’il te plaît.');
              customInput.reportValidity();
            }
            return;
          }
          if (customInput) customInput.setCustomValidity('');
          if (valueInput) valueInput.value = custom;
        }
      });

      // Prefill from links like /pages/contact?sujet=…&message=… (e.g. the gift card page).
      var prefilled = applyUrlPrefill(root);
      syncSubject(root);

      var flash = root.querySelector('[data-py-contact-flash]');
      if (!flash && prefilled) flash = root.querySelector('[data-py-contact-anchor]');
      if (flash) {
        var top = flash.getBoundingClientRect().top + window.pageYOffset - 80;
        window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    document.querySelectorAll('[data-py-contact]').forEach(bindRoot);
  })();

  } catch(e) { console.error(e); }
})();
})();
